export default function () {
	return {
		redirect: '',
    	token: ''
	}
}
